import { ScheduleType } from 'types/schedule'

export const CONFIRM_SCHEDULES = 'CONFIRM_SCHEDULES'
export const confirmSchedulesAction = (schedules: ScheduleType[]) => {
  return {
    type: 'CONFIRM_SCHEDULES',
    payload: schedules,
  }
}

export const FETCH_SCHEDULES = 'FETCH_SCHEDULES'
export const fetchSchedulesAction = (schedules: ScheduleType[]) => {
  return {
    type: 'FETCH_SCHEDULES',
    payload: schedules,
  }
}

export const INIT_SCHEDULES = 'INIT_SCHEDULES'
export const initSchedulesAction = () => {
  return {
    type: 'INIT_SCHEDULES',
    payload: [],
  }
}
